import { styled } from '@mui/material';

export const ConfigBillingListBillingsTableContainer = styled('div')({
  height: '100%',

  '& .data-table-container': {
    display: 'flex',
    flexDirection: 'column',

    '& ._loading_overlay_wrapper': {
      height: 'auto',
      flex: 1,

      '& .table': {
        marginBottom: 0,
      },
    },
  },
});
